import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCalendarClassTypesQueryVariables = Types.Exact<{
  active?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type GetCalendarClassTypesQuery = {
  __typename?: "Query";
  getCalendarClassTypes: Array<{
    __typename?: "CalendarClassType";
    uuid: string;
    name: string;
    color: string;
    isFreeSession: boolean;
    clientUuid: string | null;
  }>;
};

export type ClassTypeRowFragment = {
  __typename?: "CalendarClassType";
  uuid: string;
  name: string;
  color: string;
  isFreeSession: boolean;
  clientUuid: string | null;
};

export type GetCalendarClassTypeQueryVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
}>;

export type GetCalendarClassTypeQuery = {
  __typename?: "Query";
  getCalendarClassType: {
    __typename?: "CalendarClassType";
    uuid: string;
    name: string;
    color: string;
    description: string | null;
    isFreeSession: boolean;
  };
};

export type ClassTypeFormFragment = {
  __typename?: "CalendarClassType";
  uuid: string;
  name: string;
  color: string;
  description: string | null;
  isFreeSession: boolean;
};

export type UpdateCalendarClassTypeMutationVariables = Types.Exact<{
  input: Types.UpdateCalendarClassTypeInput;
}>;

export type UpdateCalendarClassTypeMutation = {
  __typename?: "Mutation";
  updateCalendarClassType: { __typename?: "CancelOutput"; success: boolean };
};

export type CreateCalendarClassTypeMutationVariables = Types.Exact<{
  input: Types.CreateCalendarClassTypeInput;
}>;

export type CreateCalendarClassTypeMutation = {
  __typename?: "Mutation";
  createCalendarClassType: {
    __typename?: "CalendarClassType";
    uuid: string;
    name: string;
    color: string;
    description: string | null;
    isFreeSession: boolean;
  };
};

export type DeleteCalendarClassTypeMutationVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
}>;

export type DeleteCalendarClassTypeMutation = {
  __typename?: "Mutation";
  deleteCalendarClassType: { __typename?: "CancelOutput"; success: boolean };
};

export const ClassTypeRowFragmentDoc = gql`
  fragment ClassTypeRow on CalendarClassType {
    uuid
    name
    color
    isFreeSession
    clientUuid
  }
`;
export const ClassTypeFormFragmentDoc = gql`
  fragment ClassTypeForm on CalendarClassType {
    uuid
    name
    color
    description
    isFreeSession
  }
`;
export const GetCalendarClassTypesDocument = gql`
  query GetCalendarClassTypes($active: Boolean) {
    getCalendarClassTypes(active: $active) {
      ...ClassTypeRow
    }
  }
  ${ClassTypeRowFragmentDoc}
`;

/**
 * __useGetCalendarClassTypesQuery__
 *
 * To run a query within a React component, call `useGetCalendarClassTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarClassTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarClassTypesQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCalendarClassTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCalendarClassTypesQuery,
    GetCalendarClassTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalendarClassTypesQuery,
    GetCalendarClassTypesQueryVariables
  >(GetCalendarClassTypesDocument, options);
}
export function useGetCalendarClassTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarClassTypesQuery,
    GetCalendarClassTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarClassTypesQuery,
    GetCalendarClassTypesQueryVariables
  >(GetCalendarClassTypesDocument, options);
}
export type GetCalendarClassTypesQueryHookResult = ReturnType<
  typeof useGetCalendarClassTypesQuery
>;
export type GetCalendarClassTypesLazyQueryHookResult = ReturnType<
  typeof useGetCalendarClassTypesLazyQuery
>;
export type GetCalendarClassTypesQueryResult = Apollo.QueryResult<
  GetCalendarClassTypesQuery,
  GetCalendarClassTypesQueryVariables
>;
export const GetCalendarClassTypeDocument = gql`
  query GetCalendarClassType($uuid: String!) {
    getCalendarClassType(uuid: $uuid) {
      ...ClassTypeForm
    }
  }
  ${ClassTypeFormFragmentDoc}
`;

/**
 * __useGetCalendarClassTypeQuery__
 *
 * To run a query within a React component, call `useGetCalendarClassTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarClassTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarClassTypeQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetCalendarClassTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalendarClassTypeQuery,
    GetCalendarClassTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalendarClassTypeQuery,
    GetCalendarClassTypeQueryVariables
  >(GetCalendarClassTypeDocument, options);
}
export function useGetCalendarClassTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarClassTypeQuery,
    GetCalendarClassTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarClassTypeQuery,
    GetCalendarClassTypeQueryVariables
  >(GetCalendarClassTypeDocument, options);
}
export type GetCalendarClassTypeQueryHookResult = ReturnType<
  typeof useGetCalendarClassTypeQuery
>;
export type GetCalendarClassTypeLazyQueryHookResult = ReturnType<
  typeof useGetCalendarClassTypeLazyQuery
>;
export type GetCalendarClassTypeQueryResult = Apollo.QueryResult<
  GetCalendarClassTypeQuery,
  GetCalendarClassTypeQueryVariables
>;
export const UpdateCalendarClassTypeDocument = gql`
  mutation UpdateCalendarClassType($input: UpdateCalendarClassTypeInput!) {
    updateCalendarClassType(input: $input) {
      success
    }
  }
`;
export type UpdateCalendarClassTypeMutationFn = Apollo.MutationFunction<
  UpdateCalendarClassTypeMutation,
  UpdateCalendarClassTypeMutationVariables
>;

/**
 * __useUpdateCalendarClassTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarClassTypeMutation, { data, loading, error }] = useUpdateCalendarClassTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarClassTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCalendarClassTypeMutation,
    UpdateCalendarClassTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCalendarClassTypeMutation,
    UpdateCalendarClassTypeMutationVariables
  >(UpdateCalendarClassTypeDocument, options);
}
export type UpdateCalendarClassTypeMutationHookResult = ReturnType<
  typeof useUpdateCalendarClassTypeMutation
>;
export type UpdateCalendarClassTypeMutationResult =
  Apollo.MutationResult<UpdateCalendarClassTypeMutation>;
export type UpdateCalendarClassTypeMutationOptions = Apollo.BaseMutationOptions<
  UpdateCalendarClassTypeMutation,
  UpdateCalendarClassTypeMutationVariables
>;
export const CreateCalendarClassTypeDocument = gql`
  mutation CreateCalendarClassType($input: CreateCalendarClassTypeInput!) {
    createCalendarClassType(input: $input) {
      uuid
      name
      color
      description
      isFreeSession
    }
  }
`;
export type CreateCalendarClassTypeMutationFn = Apollo.MutationFunction<
  CreateCalendarClassTypeMutation,
  CreateCalendarClassTypeMutationVariables
>;

/**
 * __useCreateCalendarClassTypeMutation__
 *
 * To run a mutation, you first call `useCreateCalendarClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarClassTypeMutation, { data, loading, error }] = useCreateCalendarClassTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarClassTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCalendarClassTypeMutation,
    CreateCalendarClassTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCalendarClassTypeMutation,
    CreateCalendarClassTypeMutationVariables
  >(CreateCalendarClassTypeDocument, options);
}
export type CreateCalendarClassTypeMutationHookResult = ReturnType<
  typeof useCreateCalendarClassTypeMutation
>;
export type CreateCalendarClassTypeMutationResult =
  Apollo.MutationResult<CreateCalendarClassTypeMutation>;
export type CreateCalendarClassTypeMutationOptions = Apollo.BaseMutationOptions<
  CreateCalendarClassTypeMutation,
  CreateCalendarClassTypeMutationVariables
>;
export const DeleteCalendarClassTypeDocument = gql`
  mutation DeleteCalendarClassType($uuid: String!) {
    deleteCalendarClassType(uuid: $uuid) {
      success
    }
  }
`;
export type DeleteCalendarClassTypeMutationFn = Apollo.MutationFunction<
  DeleteCalendarClassTypeMutation,
  DeleteCalendarClassTypeMutationVariables
>;

/**
 * __useDeleteCalendarClassTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarClassTypeMutation, { data, loading, error }] = useDeleteCalendarClassTypeMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteCalendarClassTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCalendarClassTypeMutation,
    DeleteCalendarClassTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCalendarClassTypeMutation,
    DeleteCalendarClassTypeMutationVariables
  >(DeleteCalendarClassTypeDocument, options);
}
export type DeleteCalendarClassTypeMutationHookResult = ReturnType<
  typeof useDeleteCalendarClassTypeMutation
>;
export type DeleteCalendarClassTypeMutationResult =
  Apollo.MutationResult<DeleteCalendarClassTypeMutation>;
export type DeleteCalendarClassTypeMutationOptions = Apollo.BaseMutationOptions<
  DeleteCalendarClassTypeMutation,
  DeleteCalendarClassTypeMutationVariables
>;
